import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Chip,
  useMediaQuery,
  useTheme,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { BASE_URL } from "./../../../Api/ApiUrls";
import { AuthContext } from "./../../../AuthContext/AuthContext";
import FormsBottomNavbar from "./../../Post Module/FormsBottomNavbar";
import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';


const UserVendor = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vendorToDelete, setVendorToDelete] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showFailure, setShowFailure] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
  
  const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);
  useEffect(() => {
    if (!userId) return;

    const fetchVendors = async () => {
      try {
        const response = await fetch(`${BASE_URL}/vendors/`);
        const data = await response.json();
        const userVendors = data.filter(vendor => vendor.user_id == userId);
        setVendors(userVendors);
      } catch (error) {
        console.error("Error fetching vendors:", error);
        showSnackbar('Error fetching vendors', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, [userId]);

const handleDeleteClick = async (vendor) => {
  const confirmDelete = window.confirm(`Are you sure you want to delete ${vendor.name}? This action cannot be undone.`);
  
  if (confirmDelete) {
    try {
      const response = await fetch(`${BASE_URL}/vendors/${vendor.vendor_id}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        // Remove the deleted vendor from the list
        setVendors(vendors.filter(v => v.vendor_id !== vendor.vendor_id));
        showSnackbar('Vendor deleted successfully', 'success');
      } else {
        showSnackbar('Failed to delete vendor', 'error');
      }
    } catch (error) {
      console.error("Error deleting vendor:", error);
      showSnackbar('Error deleting vendor', 'error');
    }
  }
};

const handleDelete = async () => {
  if (!vendorToDelete) return;

  try {
    const response = await fetch(`${BASE_URL}/vendors/${vendorToDelete.vendor_id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      // Remove the deleted vendor from the list
      setVendors(vendors.filter(v => v.vendor_id !== vendorToDelete.vendor_id));
      setAlertMessage(`${vendorToDelete.name} deleted successfully.`);
      setShowDeleteSuccess(true);
    } else {
      setAlertMessage(`Failed to delete ${vendorToDelete.name}.`);
      setShowDeleteFailure(true);
    }
  } catch (error) {
    console.error("Error deleting vendor:", error);
    setAlertMessage("An error occurred while trying to delete the vendor.");
    setShowDeleteFailure(true);
  } finally {
    setVendorToDelete(null);
    setMenuPropertyIdToDelete(null);
  }
};

  // const handleDeleteConfirm = async () => {
  //   if (!vendorToDelete) return;

  //   try {
  //     const response = await fetch(`${BASE_URL}/vendors/${vendorToDelete.vendor_id}/`, {
  //       method: 'DELETE',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (response.ok) {
  //       // Remove the deleted vendor from the list
  //       setVendors(vendors.filter(v => v.vendor_id !== vendorToDelete.vendor_id));
  //       showSnackbar('Vendor deleted successfully', 'success');
  //     } else {
  //       showSnackbar('Failed to delete vendor', 'error');
  //     }
  //   } catch (error) {
  //     console.error("Error deleting vendor:", error);
  //     showSnackbar('Error deleting vendor', 'error');
  //   } finally {
  //     setDeleteDialogOpen(false);
  //     setVendorToDelete(null);
  //   }
  // };

  // const handleDeleteCancel = () => {
  //   setDeleteDialogOpen(false);
  //   setVendorToDelete(null);
  // };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  // const handleSnackbarClose = () => {
  //   setSnackbar({ ...snackbar, open: false });
  // };

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading vendors...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/construction4.png')
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      pt: { xs: '56px', sm: '64px' },
      pb: { xs: '80px', sm: '90px' },
    }}>
      {/* Header */}
      <AppBar 
        position="fixed" 
        elevation={0}
        sx={{ 
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }}>
          <IconButton 
            edge="start" 
            onClick={() => navigate(-1)}
            sx={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                backgroundColor: 'rgba(255,255,255,0.2)' 
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
            My Vendors
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container 
        maxWidth="xl" 
        sx={{ 
          py: 3, 
          flex: 1,
          width: '100%',
          px: { xs: 2, sm: 3, md: 4 }
        }}
      >
        {vendors.length === 0 ? (
          <Card sx={{ 
            borderRadius: '12px', 
            boxShadow: 3, 
            p: 3, 
            textAlign: 'center',
            width: { xs: '80%', sm: '80%', md: '60%' },
            mx: 'auto'
          }}>
            <Typography variant="h6">No vendors found</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              You haven't added any vendors yet.
            </Typography>
          </Card>
        ) : (
          <Box 
            sx={{ 
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: { xs: 3, sm: 3, md: 4 },
              width: '100%'
            }}
          >
            {vendors.map((vendor) => (
              <Card 
                key={vendor.vendor_id}
                sx={{ 
                  borderRadius: '12px', 
                  overflow: 'hidden', 
                  boxShadow: 3, 
                  position: 'relative',
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'scale(1.02)'
                  },
                  width: {
                    xs: '100%',
                    sm: 'calc(50% - 12px)',
                    md: 'calc(33.33% - 16px)',
                    lg: 'calc(25% - 16px)',
                  },
                  minWidth: { xs: '280px', sm: '300px' },
                  maxWidth: { xs: '100%', sm: '400px', md: '350px' },
                }}
              >
<Box sx={{
  position: 'absolute',
  top: 8,
  right: 8,
  display: 'flex',
  gap: 1,
  zIndex: 1
}}>
  {/* Edit Button */}
  <IconButton
    onClick={() => navigate(`/user-edit-vendor/${vendor.vendor_id}`)}
    sx={{
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
      size: 'small',
      borderRadius: '50%',
    }}
  >
    <EditIcon fontSize="small" />
  </IconButton>

  {/* Delete Button */}
{/* Delete Button */}
<IconButton
  onClick={() => {
    setMenuPropertyIdToDelete(vendor.vendor_id);
    setVendorToDelete(vendor); // Store the full vendor object
    setShowDeleteConfirm(true);
  }}
  sx={{
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: '#d32f2f',
      color: 'white',
    },
    size: 'small',
    borderRadius: '50%',
  }}
>
  <DeleteIcon fontSize="small" />
</IconButton>
</Box>

                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    p: { xs: 1, sm: 3 }
                  }}>
                    <Avatar
                      alt={vendor.name || "Vendor"}
                      src={vendor.profile ? `${BASE_URL}${vendor.profile}` : ""}
                      sx={{
                        width: { xs: 100, sm: 120 },
                        height: { xs: 100, sm: 120 },
                        mb: { xs: 2, sm: 3 },
                        border: '4px solid white',
                        boxShadow: 3
                      }}
                    />
                    
                    <Typography 
                      variant={isMobile ? "h6" : "h5"} 
                      sx={{ 
                        fontWeight: 'bold', 
                        mb: 1,
                        textAlign: 'center',
                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                      }}
                    >
                      {vendor.name || "Loading..."}
                    </Typography>
                    
                    <Chip 
                      label={vendor.profession} 
                      color="primary" 
                      size={isMobile ? "small" : "medium"}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  <Divider sx={{ my: { xs: 1, sm: 2 } }} />

                  <Box sx={{ p: { xs: 1, sm: 2 } }}>
                    {[
                      { label: 'Experience', value: `${vendor.experience} year${vendor.experience !== 1 ? 's' : ''}` || "Not provided" },
                      { label: 'Mobile', value: vendor.mobile || "Not provided" },
                      { label: 'Email', value: vendor.email || "Not provided" },
                      { label: 'Address', value: vendor.address ? 
                          (isMobile ? `${vendor.address.substring(0, 30)}...` : 
                          isTablet ? `${vendor.address.substring(0, 40)}...` : 
                          `${vendor.address.substring(0, 50)}...`) : 
                          "Not provided" },
                    ].map((item, index) => (
                      <Box 
                        key={index} 
                        sx={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          mb: 2,
                          width: '100%',
                        }}
                      >
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontWeight: 'bold',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            minWidth: { xs: '70px', sm: '80px' },
                            color: 'text.secondary',
                          }}
                        >
                          {item.label}:
                        </Typography>
                        <Typography 
                          variant="body2"
                          sx={{
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            textAlign: 'right',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            maxWidth: { xs: 'calc(100% - 80px)', sm: 'calc(100% - 90px)' },
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Container>



  
  
      {/* Delete Success */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      
      {/* Delete Failure */}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}
  {showDeleteConfirm && vendorToDelete && (
  <DeleteConfirmAlert
    message={`Are you sure you want to delete ${vendorToDelete.name}? This action cannot be undone.`}
    onOk={() => {
      setShowDeleteConfirm(false);
      handleDelete();
    }}
    onCancel={() => {
      setShowDeleteConfirm(false);
      setVendorToDelete(null);
      setMenuPropertyIdToDelete(null);
    }}
  />
)}
      {/* Bottom Navigation */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

export default UserVendor;